import React, { useState } from 'react';
import SchemaList from './schema_list';
import SchemaForm from './schema_form';
import styles from '../../app.module.css';

const Schemas = ({ schemas, addSchema, editSchema, removeSchema }) => {
    const [editingSchemaName, setEditingSchemaName] = useState(null);
    const [editingSchemaData, setEditingSchemaData] = useState(null);

    const handleEdit = (schemaName) => {
        setEditingSchemaName(schemaName);
        setEditingSchemaData({ name: schemaName, ...schemas[schemaName] });
    };

    const handleSave = (name, updatedSchema) => {
        if (editingSchemaName && editingSchemaName !== '_NEW_') {
            const { name: _, ...schemaDetails } = updatedSchema;
            editSchema(editingSchemaName, schemaDetails);
        } else {
            const { name: newName, ...schemaDetails } = updatedSchema;
            addSchema(newName, schemaDetails);
        }

        setEditingSchemaName(null);
        setEditingSchemaData(null);
    };

    const handleCancel = () => {
        setEditingSchemaName(null);
        setEditingSchemaData(null);
    };

    const handleAddNew = () => {
        setEditingSchemaName('_NEW_');
        setEditingSchemaData(null);
    };

    const schemaKeys = Object.keys(schemas);

    return (
        <div className="schemas-container">
            <h3 className={styles.centeredHeading}>Schema Definitions</h3>

            {schemaKeys.length === 0 && !editingSchemaName && (
                <div>
                    <button className={styles.addNewButton} onClick={handleAddNew}>
                        + Add Schema
                    </button>
                </div>
            )}

            {schemaKeys.length > 0 && (
                <>
                    <SchemaList
                        schemas={schemas}
                        editingSchemaName={editingSchemaName}
                        editingSchemaData={editingSchemaData}
                        onEdit={handleEdit}
                        onDelete={removeSchema}
                        onSave={handleSave}
                        onCancel={handleCancel}
                    />

                    {!editingSchemaName && (
                        <button className={styles.addNewButton} onClick={handleAddNew}>
                            + Add Schema
                        </button>
                    )}
                </>
            )}

            {editingSchemaName === '_NEW_' && (
                <SchemaForm
                    initialData={null}
                    onSave={handleSave}
                    onCancel={handleCancel}
                    existingSchemas={schemaKeys}
                />
            )}
        </div>
    );
};

export default Schemas;
